// =============================================================================
// Definition
// =============================================================================
class CookieRow {

	// Constructor
	// -------------------------------------------------------------------------
	constructor(el) {
		this.el = el;

        this.init();
        this.initEvents();
	}

	// Inits
    // -------------------------------------------------------------------------
    init() {
        this.cookieRowConfirm = this.el.querySelector("#cookie-row-confirm");
        this.cookieRowSuccess = this.el.querySelector("#cookie-row-succes");
        this.analyticsCheckbox = this.el.querySelector("#sv-analytical-cookie-row");
        this.trackingCheckbox = this.el.querySelector("#sv-tracking-cookie-row");
        this.cookieConsentName = "sv-cookie-consent";

        var cookieValue = this.getCookie(this.cookieConsentName);

        if (cookieValue === "sv-analytical-cookies") {
            this.analyticsCheckbox.checked = true;
        }

        if (cookieValue === "sv-tracking-cookies") {
            this.analyticsCheckbox.checked = true;
            this.trackingCheckbox.checked = true;
        }
    }

    initEvents() {
        this.cookieRowConfirm.addEventListener("click", () => this.handleCookieRowConfirmClick());
        this.analyticsCheckbox.addEventListener("change", () => this.handleAnalyticsChange());
        this.trackingCheckbox.addEventListener("change", () => this.handleTrackingChange());
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

	// Handlers
    // -------------------------------------------------------------------------
    handleCookieRowConfirmClick() {
        var cookie = "sv-functional-cookies";

        if (this.analyticsCheckbox.checked) {
            cookie = "sv-analytical-cookies";
        }

        if (this.trackingCheckbox.checked) {
            cookie = "sv-tracking-cookies";
        }

        document.cookie = this.cookieConsentName + '=' + cookie + '; expires=Thu, 18 Dec 2999 12:00:00 UTC; path=/';

        this.cookieRowSuccess.style.display = "block";
    }
    
    handleAnalyticsChange() {
        if (!this.analyticsCheckbox.checked) {
            this.trackingCheckbox.checked = false;
        }
    }

    handleTrackingChange() {
        if (this.trackingCheckbox.checked) {
            this.analyticsCheckbox.checked = true;
        }
    }
}

export default CookieRow;
